































import {
  ref,
  computed,
  defineComponent,
  watch,
  reactive,
  toRefs,
  ComputedRef,
  getCurrentInstance,
} from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import errorCodeMap from '@/renderer/scripts/utils/errorCode/index';
interface DetailList {
  name: string;
  status: string;
  message: string;
}
export default defineComponent({
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    resultList: {
      type: Array,
      required: true,
    },
    fullList: {
      type: Array,
      required: true,
    },
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const columns = [
      {
        colKey: 'name',
        title: i18n_t('文件名'),
        ellipsis: true,
      },
      {
        width: i18n.locale === 'zh-CN' ? 80 : 120,
        colKey: 'status',
        title: i18n_t('状态'),
        ellipsis: true,
      },
      {
        width: 200,
        colKey: 'message',
        title: i18n_t('详情'),
        ellipsis: true,
      },
    ];
    const detailList: ComputedRef<DetailList[]> = computed(() =>
      (props.resultList as CoFile.SaveToNetDiscDataItem[]).map(item => {
        const fullListItem = (
          props.fullList as {
            path: string[];
            type: string;
          }[]
        ).find(fullListItem => fullListItem.path.join('/') === item.copyFrom.join('/'));
        const { type } = fullListItem || {
          type: 'file',
        };
        return {
          name: item.copyFrom[item.copyFrom.length - 1],
          status: item.status === 200 ? 'success' : 'error',
          message: item.code ? errorCodeMap[item.code] : '',
          type,
        };
      }),
    );

    // 本地分页数据
    const total = computed(() => detailList.value.length);
    const currPage = ref(1);
    const pageSize = ref(20);
    const currData = computed(() => {
      const start: number = pageSize.value * (currPage.value - 1);
      const end: number = currPage.value * pageSize.value;
      return detailList.value.slice(start, end + 1);
    });
    const pageSizeOptions = [
      {
        label: i18n_t('每页 {slot1} 条', { slot1: 20 }),
        value: 20,
      },
      {
        label: i18n_t('每页 {slot1} 条', { slot1: 50 }),
        value: 50,
      },
      {
        label: i18n_t('每页 {slot1} 条', { slot1: 100 }),
        value: 100,
      },
      {
        label: i18n_t('每页 {slot1} 条', { slot1: 200 }),
        value: 200,
      },
    ];
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    const methods = {
      onEventProxy(command: string) {
        if (command === 'cancelTask') {
          innerShow.value = false;
        }
      },
      // 获取分页数据函数
      onPageSizeChange(size: number) {
        pageSize.value = size;
      },
      onCurrentChange(current: number) {
        currPage.value = current;
      },
    };
    // 监听show的变化,当为show的时候渲染数据
    watch(
      () => props.show,
      val => {
        // 每次弹窗重新打开重置当前页和pageSize
        if (val) {
          currPage.value = 1;
          pageSize.value = 20;
        }
      },
    );
    return {
      columns,
      innerShow,
      pageSizeOptions,
      // 分页数据
      total,
      currPage,
      pageSize,
      currData,
      ...methods,
    };
  },
});
